module.exports = __webpack_public_path__ + "media/images/ui__textArrowRightLight-8f089cf7354468663f6a84992d02ee17.png";